function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#000000",
    d: "M 249.5,-0.5 C 253.5,-0.5 257.5,-0.5 261.5,-0.5C 265.479,1.31481 268.312,4.31481 270,8.5C 270.667,32.8333 270.667,57.1667 270,81.5C 264.848,90.4747 257.348,92.9747 247.5,89C 244.527,87.2352 242.36,84.7352 241,81.5C 240.333,57.1667 240.333,32.8333 241,8.5C 242.688,4.31481 245.521,1.31481 249.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.939
    },
    fill: "#000000",
    d: "M 81.5,70.5 C 87.5411,69.5928 92.8744,71.0928 97.5,75C 111.333,88.8333 125.167,102.667 139,116.5C 145.338,125.118 144.838,133.284 137.5,141C 130.049,144.801 123.049,144.135 116.5,139C 102.667,125.167 88.8333,111.333 75,97.5C 69.8652,90.9508 69.1986,83.9508 73,76.5C 75.3218,73.6047 78.1552,71.6047 81.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.939
    },
    fill: "#000000",
    d: "M 420.5,70.5 C 437.766,70.2575 443.599,78.2575 438,94.5C 423.863,109.638 409.363,124.471 394.5,139C 385.882,145.338 377.716,144.838 370,137.5C 366.735,131.472 366.735,125.472 370,119.5C 385.763,101.901 402.596,85.5679 420.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#000000",
    d: "M 280.5,511.5 C 263.833,511.5 247.167,511.5 230.5,511.5C 212.516,506.348 201.016,494.682 196,476.5C 195.667,464.5 195.333,452.5 195,440.5C 188.274,433.716 183.607,425.716 181,416.5C 183.059,387.316 173.393,362.983 152,343.5C 121.532,305.051 112.865,262.051 126,214.5C 141.937,167.563 173.77,137.397 221.5,124C 275.632,112.816 321.466,127.316 359,167.5C 392.515,210.772 399.515,258.105 380,309.5C 376.922,315.991 373.588,322.325 370,328.5C 361.756,340.081 352.756,351.081 343,361.5C 333.58,378.594 329.247,396.928 330,416.5C 327.393,425.716 322.726,433.716 316,440.5C 315.667,452.5 315.333,464.5 315,476.5C 309.984,494.682 298.484,506.348 280.5,511.5 Z M 241.5,151.5 C 285.856,148.264 320.356,164.93 345,201.5C 361.629,231.747 363.962,263.081 352,295.5C 348.841,302.488 345.174,309.154 341,315.5C 331.576,325.587 322.909,336.253 315,347.5C 304.082,367.417 298.749,388.75 299,411.5C 296.187,416.996 291.687,420.162 285.5,421C 265.5,421.667 245.5,421.667 225.5,421C 219.313,420.162 214.813,416.996 212,411.5C 212.353,386.573 206.02,363.573 193,342.5C 183.244,332.081 174.244,321.081 166,309.5C 149.385,278.908 147.051,247.241 159,214.5C 175.559,179.141 203.059,158.141 241.5,151.5 Z M 225.5,451.5 C 245.5,451.5 265.5,451.5 285.5,451.5C 285.666,456.511 285.499,461.511 285,466.5C 284.167,475.333 279.333,480.167 270.5,481C 260.5,481.667 250.5,481.667 240.5,481C 231.667,480.167 226.833,475.333 226,466.5C 225.501,461.511 225.334,456.511 225.5,451.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.955
    },
    fill: "#000000",
    d: "M 243.5,180.5 C 249.509,180.334 255.509,180.501 261.5,181C 269.915,185.348 272.748,192.181 270,201.5C 268.5,205.667 265.667,208.5 261.5,210C 235.191,210.001 218.358,222.501 211,247.5C 204.705,254.914 197.205,256.414 188.5,252C 182.882,247.071 181.049,240.905 183,233.5C 193.196,204.337 213.363,186.67 243.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#000000",
    d: "M -0.5,261.5 C -0.5,257.5 -0.5,253.5 -0.5,249.5C 1.31481,245.521 4.31481,242.688 8.5,241C 32.8333,240.333 57.1667,240.333 81.5,241C 90.4747,246.152 92.9747,253.652 89,263.5C 87.2352,266.473 84.7352,268.64 81.5,270C 57.1667,270.667 32.8333,270.667 8.5,270C 4.31481,268.312 1.31481,265.479 -0.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#000000",
    d: "M 511.5,249.5 C 511.5,253.5 511.5,257.5 511.5,261.5C 509.685,265.479 506.685,268.312 502.5,270C 478.167,270.667 453.833,270.667 429.5,270C 420.525,264.848 418.025,257.348 422,247.5C 423.765,244.527 426.265,242.36 429.5,241C 453.833,240.333 478.167,240.333 502.5,241C 506.685,242.688 509.685,245.521 511.5,249.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.15adcc369c58ab8a12428c36d8050e73.svg";
export { ForwardRef as ReactComponent };